import React,{ useEffect,useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import SimpleForm from 'components/SimpleForm';
import SubmitButton from 'components/SubmitButton';

import plans from '.';
const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      },
  }));
const  AddPlan = (props) => {
    const classes = useStyles();
    const [plan, setPlan] = useState({
        product_name: '',
        currency: '',
        amount: '',
        interval: ''
    }); 
    const handleChange = (event) => {
        console.log(event.target.value);
        setPlan({...plans,[event.target.name]:event.target.value})
    }
    const handlePlan = () => {
        console.log("testing",plan);
    }
  return (
    <div>
      <Dialog open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">ADD PLAN</DialogTitle>
        <SimpleForm title="" onSubmit={handlePlan}> 
          <DialogContent>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <TextField autoFocus margin="dense" name="product_name"  onChange={handleChange} id="currency" label="Product Name" type="text" fullWidth/>
                </Grid>
                <Grid item xs={6}>
                    <TextField autoFocus margin="dense" name="amount" onChange={handleChange}  id="amount" label="Amount" type="number" fullWidth/>
                </Grid>
                <Grid item xs={6}>
                    <TextField autoFocus margin="dense" name="currency" onChange={handleChange} id="currency" label="currency" type="text" fullWidth/>
                </Grid>
                <Grid item xs={6}>
                    <TextField autoFocus margin="dense" name="interval" onChange={handleChange} id="interval" label="Interval" type="text" fullWidth/>
                </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={props.handleClose} color="primary">
                Cancel
            </Button>
            <Button type="submit" color="primary">
                Submit
            </Button>
          </DialogActions>
          </SimpleForm>
      </Dialog>
    </div>
  );
}
    

export default AddPlan;
